export default "__VITE_ASSET__BKgIsLvL__"